import type { OemModelStatusRow } from '../services/vehicleService';

export function buildOemModelStatusMatrix(
  source: OemModelStatusRow[],
  oemId = '',
  modelId = '',
  normalizeStatus: (status: string) => string = (status) => status,
) {
  const rows = source.filter((row) => (!oemId || row.oemId === oemId) && (!modelId || row.modelId === modelId))
    .map((row) => {
      const statusCounts: Record<string, number> = {};
      for (const [status, value] of Object.entries(row.statusCounts)) {
        const canonical = normalizeStatus(status);
        statusCounts[canonical] = (statusCounts[canonical] || 0) + value;
      }
      return { ...row, statusCounts, total: Object.values(statusCounts).reduce((sum, count) => sum + count, 0) };
    });
  const statusTotals: Record<string, number> = {};
  let grandTotal = 0;
  for (const row of rows) {
    grandTotal += row.total;
    for (const [status, count] of Object.entries(row.statusCounts)) {
      statusTotals[status] = (statusTotals[status] || 0) + count;
    }
  }
  return { rows, statusTotals, grandTotal };
}
